// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pdhv","controls":"styles_controls__3Fo3U","charLimit":"styles_charLimit__NUXyP","input":"styles_input__24jGO","send":"styles_send__3Fug4"};